var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('video',{staticClass:"centered-video",attrs:{"muted":"","loop":"","autoplay":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require('@/assets/images/video/VIDEO GIF NQA WEB.mp4'),"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }